export const cpfMask = cpf => {
  return cpf
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}

export const cnpjMask = cnpj => {
  const c = (cnpj || '')
    .replace(/[^a-zA-Z0-9]/g, '')
    .toUpperCase()
    .slice(0, 14);
  const base = c.slice(0, 12);
  const dv = c.slice(12, 14).replace(/\D/g, '');
  let out = base.slice(0, 2);
  if (base.length > 2) out += '.' + base.slice(2, 5);
  if (base.length > 5) out += '.' + base.slice(5, 8);
  if (base.length > 8) out += '/' + base.slice(8, 12);
  if (dv.length > 0) out += '-' + dv;
  return out;
}

export const cpfCnpjMask = value => {
  const core = (value || '').replace(/[^a-zA-Z0-9]/g, '');
  if (/[a-zA-Z]/.test(core)) return cnpjMask(value);
  return core.length <= 11 ? cpfMask(value) : cnpjMask(value);
}

export const phoneMask = phone => {
  return phone
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')

}

export const numberCreditCardMask = numberCreditCard => {
  return numberCreditCard
    .replace(/\D/g,"")
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1 $2')
    .replace(/(\d{4})(\d)/, '$1')
}

export const validateCardMask = validateCard => {
  return validateCard
    .replace(/\D/g,"")
    .replace(/^(\d{2})(\d)/g,"$1$2")
    .replace(/(\d{2})(\d)/, '$1/$2')
    .replace(/(\d{4})(\d)/, '$1')
}

export const cvvCardMask = cvvCard => {
  return cvvCard
    .replace(/\D/g,"")
    .replace(/(\d{4})(\d)/, '$1')
}